var _circle, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#7BD0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 7c-6 0-10 6-10 14 0 8 4 19 10 19s10-11 10-19c0-8-4-14-10-14z",
    fill: "#FFD3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17c0-6 4-10 10-10-5 0-8 4-8 10 0 7 3 16 8 19-6-3-10-12-10-19zm20 0c0-6-4-10-10-10 5 0 8 4 8 10 0 7-3 16-8 19 6-3 10-12 10-19z",
    fill: "#FF9ECE",
    opacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19,
    cy: 19,
    rx: 2,
    ry: 3,
    fill: "#000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 19,
    rx: 2,
    ry: 3,
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17c1-1 2-1 2 0s-1 2-2 1v-1zm12 0c-1-1-2-1-2 0s1 2 2 1v-1z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29c-3 0-5-1-5-3h10c0 2-2 3-5 3z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h12s-1 6-6 6-6-6-6-6z",
    fill: "#FF9ECE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h12s-1 4-6 4-6-4-6-4z",
    fill: "#FFB5D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16c3-6 15-6 18 0-1-5-17-5-18 0zm9 12h1v3h-2v-3z",
    fill: "#FF3399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnime);
export default __webpack_public_path__ + "static/media/anime.ceca48f39c7480818989a354ebaf0889.svg";
export { ForwardRef as ReactComponent };